import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as AppActions from '@store/actions/app.actions';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(
    private store: Store<{ date: Date }>,
  ) { }

  show(message: string) {
    this.store.dispatch({ type: AppActions.showToast.type, message });
  }

}
